import { useCallback } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { Button } from '@/components/ui/button';
import { useBillingState } from '@/modules/billing/hooks/useBillingState';
import { getPermissions } from '@/redux/permissions/selectors';
import { selectAccountSlug } from '@/redux/session/selectors';
import { trackEvent } from '@/segment/segment';
import { actions } from '@/shared/types/permissions';
import { EventName } from '@/shared/types/segment';
import { RootState } from '@/shared/types/state';

export const UpgradeButton = () => {
  const slug = useSelector(selectAccountSlug);
  const navigate = useNavigate();
  const billingState = useBillingState();
  const isTrial = billingState?.plan_type === 'trial';
  const { t } = useTranslation();

  const canReadBilling = useSelector((state: RootState) =>
    getPermissions(state, 'billing', actions.READ)
  );

  const handleClickUpgrade = useCallback(() => {
    trackEvent(EventName.ClickUpgradePlan);
    navigate(`/${slug}/account/billing`, { state: { shouldTriggerAction: Date.now() } });
  }, [slug, navigate]);

  if (isTrial && canReadBilling) {
    return (
      <Button size="sm" onClick={handleClickUpgrade}>
        <span className="text-sm leading-5 font-semibold text-text-primary-foreground">
          {t('billing.upgrade')}
        </span>
      </Button>
    );
  }

  return null;
};
